import { X } from "lucide-react";
import { useStore } from "../state/store";

export function ProgressBar() {
  const job = useStore((s) => s.yearJob);
  const cancel = useStore((s) => s.cancelYearComputation);
  if (!job.running) return null;

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-30 bg-card border border-border rounded-lg shadow-lg px-4 py-3 w-96 max-w-[90%]">
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm font-medium">Jaarschaduw berekenen…</div>
        <button
          onClick={cancel}
          className="text-muted-foreground hover:text-foreground"
          title="Afbreken"
        >
          <X size={16} />
        </button>
      </div>
      <div className="h-2 bg-secondary rounded overflow-hidden">
        <div
          className="h-full bg-blue-600 transition-all duration-150"
          style={{ width: `${Math.max(2, Math.min(100, job.pct))}%` }}
        />
      </div>
      <div className="mt-1 text-xs text-muted-foreground flex justify-between">
        <span>{job.phase}</span>
        <span>{job.pct.toFixed(0)}%</span>
      </div>
    </div>
  );
}
